
import state from './moduleTelephoneServerState.js'
import mutations from './moduleTelephoneServerMutations.js'
import actions from './moduleTelephoneServerActions.js'
import getters from './moduleTelephoneServerGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
